import React, { useContext, useState, useEffect } from 'react';
import { Checkbox, CircularProgress, List, ListItem, makeStyles } from '@material-ui/core';
import LimitedBackdrop from '../../components/UI/LimitedBackdrop';
import { AppContext } from '../../contexts/AppContext';
import { separations } from '../../constants/StyleConstants';
import { Fragment } from 'react';
import EmployeesApi from '../../services/EmployeesApi';
import DialogAcerBrag from '../../components/UI/DialogAcerBrag';

const useStyles = makeStyles(theme => ({
  ...separations,
  dialogContainer: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '30em',
  },
  contiguous: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: '1em',
  },
}));

const DisassociateEmployeeDialog = ({ open, setOpen, reloadGrid, employee }) => {
  const classes = useStyles();
  const { showError, showWarning, showSuccess } = useContext(AppContext);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [checkedState, setCheckedState] = useState({})

  useEffect(() => {
    !open && setCheckedState({})
  }, [open])

  const handleCheckboxChange = (item) => {
    setCheckedState(prevState => ({
      ...prevState,
      [item]: !prevState[item]
    }))
  }

  const validateAndConfirm = () => validateChecked() && confirmDisassociate();

  const confirmDisassociate = () => {
    setOpenBackDrop(true);

    const suppliers = Object.keys(checkedState).filter(key => checkedState[key]);

    const suppliersIds = suppliers.map(s => s.split(';')[1]);

    let request = suppliersIds.map((s) => {
      return {
        supplierId: s,
        employeeId: employee.id
      };
    })

    return EmployeesApi.disassociate(request)
      .then(res => {
        showSuccess('El proveedor se ha desasociado con éxito');
        reloadGrid();
      })
      .catch(error => {
        const errorMsg = 'Error al desasociar el proveedor';
        showError(errorMsg, error);
        throw new Error(errorMsg);
      })
      .finally(() => {
        setOpen(false);
        setTimeout(() => setOpenBackDrop(false), 250);
      });
      
  };

  const validateChecked = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = !Object.values(checkedState).some(value => value))) {
      errorMessages.push('Debe seleccionar al menos un proveedor');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  return (
    <Fragment>

    <DialogAcerBrag open={open} setOpen={setOpen} title={`Desasociar proveedores del empleado: ${employee.name} `} action={validateAndConfirm}>
      <LimitedBackdrop open={openBackDrop}>
        <CircularProgress color="primary" />
      </LimitedBackdrop>
      <h3 style={{ marginTop: '5px' }}>Seleccione los proveedores que desea desasociar</h3>
      <List style={{ marginTop: '5px' }}>
        {employee.supervisingSuppliers.map((supplier, index) => (
          <ListItem key={index} style={{ display: 'flex', justifyContent: 'space-between', border: '1px solid #2176cd', height: '40px'}}>

            <span>{supplier.split(';')[0]}</span>
            <Checkbox 
              color='primary'
              checked={checkedState[supplier]}
              onChange={() => handleCheckboxChange(supplier)}
            />
          </ListItem>
        ))}
      </List>
    </DialogAcerBrag>
    </Fragment>
  );
};
export default DisassociateEmployeeDialog;